import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const container = css`
  display: flex;
  flex-flow: column;
  height: 120px;
  width: 100%;
`;

export const placementThumbnail = css`
  position: relative;
  height: 120px;
`;

export const noImageThumbnail = css`
  ${placementThumbnail};
  background-color: ${colors.gray.light};
  height: 120px;
  cursor: default;
`;

export const thumbnail = css`
  ${placementThumbnail};
  flex: 1;
  cursor: pointer;
  img {
    object-fit: cover;
    height: 120px;
    width: 100%;
  }
`;

export const expandedThumbnailBackground = css`
  background-color: #1e2535;
  opacity: 0.4;
`;

const placement = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const collapsableThumbnailIcon = css`
  ${placement};
  fill-opacity: 0.9;
`;

const thumbnailBackground = css`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  opacity: 0.9;
`;

const thumbnailIconSize = css`
  width: 22px;
  height: 22px;
`;

export const thumbnailIcon = css`
  ${placement};
  ${thumbnailBackground};
  background-color: ${colors.black};
  color: ${colors.white};
  svg {
    ${placement};
    ${thumbnailIconSize};
  }
`;

export const noImageThumbnailIcon = css`
  ${placement};
  ${thumbnailBackground};
  background-color: ${colors.gray.lightest};
  color: ${colors.gray.light};
  svg {
    ${placement};
    ${thumbnailIconSize};
  }
`;
